"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationUserCommunicationPreferenceScopeEnum = exports.NotificationUserCommunicationPreferenceTypeEnum = void 0;
exports.NotificationUserCommunicationPreferenceTypeEnum = {
    Email: 'email',
    Push: 'push',
};
exports.NotificationUserCommunicationPreferenceScopeEnum = {
    PersonalizedRecommendation: 'personalized_recommendation',
    ClinicalProgramRecommendation: 'clinical_program_recommendation',
    ConditionRecommendation: 'condition_recommendation',
    MentalHealthScreening: 'mental_health_screening',
    TipsAndSuggestion: 'tips_and_suggestion',
    ReEngagement: 're_engagement',
    Winback: 'winback',
    Updates: 'updates',
    AppUpdate: 'app_update',
    NewProgram: 'new_program',
    Newsletter: 'newsletter',
    Program: 'program',
    Marketing: 'marketing',
};
//# sourceMappingURL=notification-user-communication-preference.js.map